import React, { useState, useEffect } from "react";
import ReactApexChart from 'react-apexcharts';
import BaseAPI from "../../api/apiurl";

const ApexChatSP = () => {

  const [open, setOpen] = useState(null);
  const [closed, setClosed] = useState(null);
  const [resolved, setResolved] = useState(null);
  const [inprogress, setInprogress] = useState(null);
  const [registered, setRegistered] = useState(null);

  const Dashboardcount = () => {
    const company_id = localStorage.getItem('companyid');
    const customer_id = localStorage.getItem('customerid');

    if (company_id && customer_id) {
      const apiUrl = `${BaseAPI}servicedash?company_id=${company_id}&customer_id=${customer_id}`;

      // Make an HTTP GET request using fetch
      fetch(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else {
            throw new Error('Failed to fetch data');
          }
        })
        .then((data) => {
          setOpen(parseFloat(data.data[0].open));
          setClosed(parseFloat(data.data[0].closed));
          setResolved(parseFloat(data.data[0].resolved));
          setInprogress(parseFloat(data.data[0].inprogress));
          setRegistered(parseFloat(data.data[0].registered));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      console.log('company_id and customer_id not found in local storage');
    }
  };

  useEffect(() => {
    Dashboardcount();
  }, []);


  const series = [
    {
      name: 'Open',
      data: [open],
    },
    {
      name: 'Closed',
      data: [closed],
    },
    {
      name: 'Resolved',
      data: [resolved],
    },
    {
      name: 'In-Progress',
      data: [inprogress],
    },
    {
      name: 'Registered',
      data: [registered],
    },
  ];

  // Function to change a single value in the 'Open' series
  const changeOpenValue = (newValue, dataIndex) => {
    const updatedSeries = [...series];
    updatedSeries[0].data[dataIndex] = newValue;
    return updatedSeries;
  };

  // Call the function to change a value in the 'Open' series
  const updatedSeries = changeOpenValue( 0 , 1);

  const options = {
    chart: {
      type: 'bar',
      height: 350,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: '13px',
              fontWeight: 100,
            },
          },
        },
      },
    },
    legend: {
      position: 'right',
      offsetY: 40,
    },
    fill: {
      opacity: 2,
    },
    xaxis: {
      categories: ['last 30 days'], // Add your x-axis labels here
    },
  };


  return (
    <div id="chart">
      <ReactApexChart options={options} series={updatedSeries} type="bar" height={350} />
    </div>
  );
};

export default ApexChatSP;


